/**
 * DuckDuckGo Search & Tracker Protection
 *
 * A privacy extension that is itself trivially enumerable: one static resource exposed
 * to every origin. Detecting a privacy tool is a meaningful fingerprinting signal,
 * since it is comparatively rare and therefore distinguishing.
 * Manifest verified against version 2026.5.22.
 */
import { probeImage } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';
const ID = 'bkdgflcldnnnapblkhphbgpggdiikppg';
export const duckduckgo: ExtensionDefinition = {
  id: ID,
  name: 'DuckDuckGo Search & Tracker Protection',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 3_000_000,
  notes:
    'Exposes its logo to <all_urls>, so a privacy extension is itself a fingerprinting ' +
    'signal. Contrast with uBlock Origin Lite, which exposes nothing.',
  signals: [
    { id: 'war-logo-small', kind: 'web-accessible-resource',
      description: 'Load img/logo-small.svg via <img> — its only broadly-exposed resource.',
      weight: 1, run: () => probeImage(ID, 'img/logo-small.svg') },
  ],
};
